var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailSetting = function SvgEmailSetting(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.535 17H9c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C1 13.2 1 11.8 1 9c0-1.994 0-3.278.197-4.238m19.606 0-5.508 3.505c-1.556.99-2.335 1.486-3.171 1.679a5 5 0 0 1-2.248 0c-.836-.193-1.614-.689-3.171-1.68L1.197 4.763m19.606 0a4.003 4.003 0 0 0-.348-1.032 5 5 0 0 0-2.185-2.185C17.2 1 15.8 1 13 1H9c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 1.545 3.73a4.006 4.006 0 0 0-.348 1.032m19.606 0c.175.852.194 1.958.197 3.59M17 15h.01M17 11l1.179 1.155 1.65.017.017 1.65L21 15l-1.154 1.179-.018 1.65-1.65.017L17 19l-1.179-1.154-1.65-.018-.016-1.65L13 15l1.155-1.179.017-1.65 1.65-.016L17 11Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailSetting);
export default ForwardRef;